import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { PILOT_PROJECT_ID } from '../../components/TwoDays/model/mockData';

/** 팀 워크보드(/2days/board/:slug) 첫 화면 — Dashboard. 팀 링크로 들어와도 여기로. Pre-join 뒤 ?tour=1 (코치마크)을 그대로 넘긴다 */
export const TwoDaysBoardIndex = () => {
  const { search } = useLocation();
  return <Navigate replace to={`dashboard${search}`} />;
};

/** /2days → 파일럿 프로젝트. 프로젝트 목록이 생기면 여기서 고른다 */
export const TwoDaysEntry = () => (
  <Navigate replace to={`/2days/projects/${PILOT_PROJECT_ID}/tasks`} />
);
